import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  student: {},
  fetchedStudent: [],
  fetchResponse: {},
  singleStudent: {},
}

const StudentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    requestPending: (state) => {
      state.isLoading = true
    },
    studentAccountSuccess: (state, { payload }) => {
      state.isLoading = false
      state.student = payload || {}
    },
    studentFechSuccess: (state, { payload }) => {
      state.isLoading = false
      state.fetchResponse = payload || {}
      state.fetchedStudent = payload.student
    },
    getSelectedStudent: (state, { payload }) => {
      state.isLoading = false
      state.singleStudent = payload
    },
    requestFail: (state, { payload }) => {
      state.isLoading = false
      state.fetchedStudent = payload || {}
    },
  },
})
const { reducer, actions } = StudentSlice
export const {
  requestPending,
  studentFechSuccess,
  getSelectedStudent,
  studentAccountSuccess,
  requestFail,
} = actions
export default reducer
